module.exports = __webpack_public_path__ + "static/media/articlebottom.bebf6a91.png";